// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ANONYMOUS_USERNAME = "anonym";
export const FORUM_REPORTED = "nahl\u00e1sen\u00e9";
export const NEW_FEMININE = "Nov\u00e1";
export const POST_DELETED_BY_ADMIN = "Pr\u00edspevok zmazan\u00fd adminom";
export const POST_DELETED_BY_AUTHOR = "Pr\u00edspevok zmazan\u00fd autorom";
export const SHOW = "Zobraz";
